module.exports = __webpack_public_path__ + "img/img_aviodPhoney_07.10a68179.jpg";